import { load } from "js-yaml";
import React, { useEffect, useState } from "react";
import "./SocialMediaLinks.css";
const SocialMediaLinks = React.forwardRef((props, ref) => {
  const [links, setLinks] = useState({
    Pinterest: "",
    Instagram: "",
    Facebook: "",
    Twitter: "",
  });

  useEffect(() => {
    fetch("links.yaml")
      .then((r) => r.text())
      .then((text) => {
        return load(text);
      })
      .then((data) => {
        setLinks(data);
      });
  }, []);

  return (
    <div ref={ref} className="socialmedia">
      <a href={links.Pinterest}>
        <img className="show" src={"/assets/images/pinterest.svg"} />
      </a>
      <a href={links.Twitter}>
        <img className="show" src={"/assets/images/twitter.svg"} />
      </a>
      <a href={links.Instagram}>
        <img className="show" src={"/assets/images/instagram.svg"} />
      </a>
      <a href={links.Facebook}>
        <img className="show" src={"/assets/images/facebook.svg"} />
      </a>
    </div>
  );
});

export default SocialMediaLinks;
